import { Vap } from "@lingbo/effects/extend/alphaVideo";
export function preloadVap(vapConfig) {
    try {
        Vap.loadJson({
            src: vapConfig.mtapConfigJson
        });
        Vap.loadJson({
            src: vapConfig.configJson
        });
        Vap.loadVideo({
            src: vapConfig.mp4
        });
    }
    catch (error) {
        // empty
    }
}
